export const BREAKPOINT_MOBILE = 599;
export const BREAKPOINT_TABLET = 1024;
export const ENABLE_BUTTON_SUBMIT_ACTION_NAME = "EnableButtonSubmit";
export const IMAGE_FILE_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const MOVIE_FILE_TYPES = ["video/mp4"];
